<h2 mat-dialog-title>Alterar status - {{ data.param.id }}</h2>
<mat-dialog-content class="mat-typography">
  <page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>

  <div *ngIf="encounter">
    <b> {{ encounter.type }}:</b> {{ encounter.name }} <span *ngIf="encounter.organization"> - {{ encounter.organization.name }}</span> <br />
    <b> Data e Hora:</b> {{ layout.dateTimeFormat(encounter.startDate) }}
  </div>
  <mat-form-field class="example-full-width" appearance="outline">
    <mat-label>Status</mat-label>
    <mat-select [formControl]="statusControl">
      <mat-option *ngFor="let item of scheduleStatus" [value]="item.id">
        {{ item.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field *ngIf="requiresAttendanceCode(statusControl.value)" class="example-full-width" appearance="outline">
    <mat-label>Código informado pelo paciente</mat-label>
    <input matInput [(ngModel)]="attendanceCode" maxlength="6" autocomplete="off" />
  </mat-form-field>
  <p class="alert-danger" *ngIf="attendanceCodeError">{{ attendanceCodeError }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" [mat-dialog-close]="false">Cancelar</button>
  <button mat-flat-button [disabled]="loading || statusControl.invalid" color="primary" (click)="saveStatus()" cdkFocusInitial>Salvar</button>
</mat-dialog-actions>
